import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { HttpClient } from '@angular/common/http';
import { EncryptService } from '../../core/http/http-encrypt.service';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Injectable({
  providedIn: 'root'
})
export class UploadPdfService {
  encriptedData: string;

  constructor(
    private httpClient: HttpClient,
    public toastr: ToastrService,
    private encryptService: EncryptService
  ) { }

  uploadVDPDF(taskTypeJsonId: number, payload, displayName: string) {
    let name = this.encryptService.toEncrypt(displayName).toUpperCase();
    return this.httpClient.post(
      `/vd/pdfToWorkflow/upload/pdfToJsonViewer/${taskTypeJsonId}/${name}`,
      payload)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response && response.status === 200) {
            this.toastr.success(response.message, 'Success');
            return response;
          } else {
            CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            return null;
          }
        })
      );
  }

  getUploadedFiles(taskTypeJsonId: number) {
    return this.httpClient.get(`/vd/pdfToWorkflow/fetchAllByTaskTypeJsonId/${taskTypeJsonId}`)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response && response.status === 200) {
            this.toastr.success(response.message, 'Success');
            return response;
          } else {
            CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            return null;
          }
        })
      );
  }

  deleteVDPDF(id: number) {
    return this.httpClient.delete(`/vd/pdfToWorkflow/delete/${id}`)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response && response.status === 200) {
            this.toastr.success(response.message, 'Success');
            return true;
          } else {
            CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            return false;
          }
        })
      );
  }

  getVisaCreationType(taskTypeJsonId: number) {
    return this.httpClient.get(`/vd/taskType/${taskTypeJsonId}`)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response && [200, 204].includes(response.status)) {
            return response;
          } else {
            CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            return null;
          }
        })
      );
  }

}
